import { HotelReserveCardContent } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-content";
import { HotelReserveCardFooter } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-footer";
import { HotelReserveCardFullCapacity } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-full-capacity";
import { HotelReserveCardRacks } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-racks";
import { useHotelReserveCard } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card.hook";
import { HotelReservedCardPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card.types";

export const HotelReserveCard = (
  properties: HotelReservedCardPropertiesType
) => {
  const { availableRooms, rackIncluded } = properties;
  const {
    hotelReserveCardContentProps,
    hotelReserveCardFooterProps,
    hotelReserveCardFullCapacityProps,
    hotelReserveCardRacksProps,
    reference
  } = useHotelReserveCard(properties);

  return (
    <div
      className="bg-on-color-high-emphasis shadow-1 flex min-w-[218px] flex-col overflow-hidden rounded-xl xl:max-w-[1104px]"
      ref={reference}
    >
      <div className="flex flex-row">
        {/*{Boolean(hotelReserveCardContentProps?.img) && (*/}
        {/*  <div className="hidden w-[124px] xl:block">*/}
        {/*    <LazyImage*/}
        {/*      alt="room"*/}
        {/*      className="size-full object-cover"*/}
        {/*      loading="lazy"*/}
        {/*      src={hotelReserveCardContentProps?.img}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*)}*/}
        <div className="w-min grow">
          <HotelReserveCardContent {...hotelReserveCardContentProps} />
          <div className="bg-outline-thin h-px w-full" />
          {availableRooms || rackIncluded ? (
            <HotelReserveCardFooter {...hotelReserveCardFooterProps} />
          ) : (
            <HotelReserveCardFullCapacity
              {...hotelReserveCardFullCapacityProps}
            />
          )}
        </div>
      </div>
      <HotelReserveCardRacks {...hotelReserveCardRacksProps} />
    </div>
  );
};
